import React from "react";
import PropTypes from "prop-types";
import { Accordion } from "react-bootstrap";
import MarkerScale from "../MarkerScale";
import { cleanDetails } from "../../../../utils/utils";

/**
 * MarkerScaleGraph — inline detail view rendered inside the NavItem accordion body.
 * No drawer/panel chrome — just the content.
 */

function buildFaqs(name, details = {}, status) {
  return [
    details.what_is  && { q: `What is ${name}?`,                                         a: cleanDetails(details.what_is) },
    details.what_can && { q: `What can ${name} tell me about my health?`,                 a: cleanDetails(details.what_can) },
    details.meaning  && { q: `What does it mean if my ${name} is ${status}?`,          a: cleanDetails(details.meaning)  },
    details.symptoms && { q: `What symptoms could I have if my ${name} is ${status}?`, a: cleanDetails(details.symptoms) },
    details.actions  && { q: `What can I do if my ${name} is ${status}?`,              a: cleanDetails(details.actions)  },
    details.repeat   && { q: `When should I repeat my test?`,                             a: cleanDetails(details.repeat) },
  ].filter(Boolean);
}

export function MarkerScaleGraph({ marker, graphContent, isScale=true,isMobile }) {

  const status = ["normal", "green"].includes(marker?.result)
    ? "normal"
    : marker?.result || "normal";

  const resultLabel =
    status === "normal" ? "Normal"
    : status === "low"  ? "Low"
    : status === "high" ? "High"
    : status.charAt(0).toUpperCase() + status.slice(1);

  const summaryText = cleanDetails(marker?.details?.meaning) || null;
  const faqs = buildFaqs(marker?.name, marker?.details, status);

  return (
    <div className={`mdd__scroll ${isMobile ? "px-0 py-0": "px-2 py-2"}`}>
      <div className={`${(isScale && isMobile) && "scale-faq-content"}`}>
        {/* Scale */}
        {isScale && (
        <div className={`${(isScale && isMobile) && "px-2"} mdd__scale`}>
          <MarkerScale {...marker} isGraph={true} />
        </div>
        )}

        {/* Summary box */}
        {summaryText && (
          <div className={`mdd__summary mdd__summary--${status}`}>
            <p className="mdd__summary-title">
              Your result is <strong>{resultLabel.toLowerCase()}</strong>.
            </p>
            <p className="mdd__summary-body">{summaryText}</p>
          </div>
        )}

        {/* FAQ Accordion */}
        {faqs.length > 0 && (
          <Accordion className="mdd__faq" flush>
            {faqs.map((faq, i) => (
              <Accordion.Item key={i} eventKey={String(i)}>
                <Accordion.Header className={isMobile && "fs-16"}>{faq.q}</Accordion.Header>
                <Accordion.Body className={isMobile && "fs-15"}>{faq.a}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        )}
      </div>

      {/* Graph */}
      {graphContent && <div className="mdd__graph">{graphContent}</div>}
    </div>
  );
}

MarkerScaleGraph.propTypes = {
  marker: PropTypes.shape({
    name:          PropTypes.string,
    code:          PropTypes.string,
    value:         PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    units:         PropTypes.string,
    result:        PropTypes.string,
    boundary:      PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type:          PropTypes.string,
    decision_type: PropTypes.string,
    details: PropTypes.shape({
      what_is:  PropTypes.string,
      what_can: PropTypes.string,
      meaning:  PropTypes.string,
      symptoms: PropTypes.string,
      actions:  PropTypes.string,
      repeat:   PropTypes.string,
    }),
  }),
  graphContent: PropTypes.node,
};